import React, { useEffect, useState } from 'react'
import { formatEther } from '@ethersproject/units'
import { useContractCall, useContractFunction, useEtherBalance, useEthers, getExplorerAddressLink, ChainId, useCall} from '@usedapp/core'
import { ContainerCustom, ContentBlock, ContentRow, MainContent, Section, SectionRow } from '../components/base/base'
import { Label } from '../typography/Label'
import { TextInline , Text} from '../typography/Text'
import { Title } from '../typography/Title'
import { BigNumber, ethers, Signer, utils } from 'ethers'
import { Contract } from '@ethersproject/contracts'
import { formatUnits } from '@ethersproject/units'
import { ShareIcon } from '../components/Transactions/Icons'
import { Link } from '../components/base/Link'


import { AccountButton } from '../components/account/AccountButton'
import { Row, Col, Image, Tooltip, OverlayTrigger } from 'react-bootstrap'

import styled from 'styled-components'
import logo from './loader.gif';
import {Badge } from 'react-bootstrap'
import "bootstrap-icons/font/bootstrap-icons.css";
import { ERC1155Interface, LIKESV0Interface, LIKESPROXYV0Interface} from '../interfaces/interfaces'
import { TypedContract } from '@usedapp/core/dist/esm/src/model/types'



const LIKES_PROXY_V0_ADDRESS = '0x83D29F5e551A8a8c3cf3354baD655862d2820A31'
const PROJ_ADDRESS_1 = '0xfc38ba53741e1c4d55c26b20dd7299ed62057dca';
const PROJ_ADDRESS_2 = '0x3bF1dEEBEe2cD1f632FcC4967BF13173e02eE21e';
const PROJ_ADDRESS_3 = '0xf09617D61BC5497b2cBD0F5205C274BFf057b734';

const NULL_ADDRESS = '0x0000000000000000000000000000000000000000'

export const LikesProxyV0ABI = [
  "function likeProject(address projectAddress, address reciever) public payable",
  "function getPriceForProject(address projectAddress) public view returns (uint256)"
];


export const contact1155 = [
  "function balanceOfBatch(address[] memory accounts, uint256[] memory ids) public view returns (uint256[] memory)"
];


const get1155Contract = (signer: Signer, contractAddress:string): Contract => {
  return new Contract(contractAddress, [
    "function balanceOfBatch(address[] memory accounts, uint256[] memory ids) public view returns (uint256[] memory)"
  ],signer);
}



const formatter = new Intl.NumberFormat('en-us', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const formatBalance = (balance: BigNumber | undefined) =>
  parseFloat(formatEther(balance ?? BigNumber.from('0')))

export function Home() {
  const { account, library,chainId } = useEthers()
  const userBalance = useEtherBalance(account)
  // const signer = library?.getSigner();
  const likesInterface = new utils.Interface(LikesProxyV0ABI);
  let contract: Contract|null = null;
  if (account && account !== undefined) {
    contract =  new Contract(LIKES_PROXY_V0_ADDRESS, likesInterface, library as any);
  } else {
    contract =  new Contract(NULL_ADDRESS, likesInterface, library as any);
  }
  let tokenBalances: any = [];


  const [darkBitsTokenBalance, setDarkBitsTokenBalance] = useState<any>();
  const [metaPortalBalance, setMetaPortalBalance] = useState<any>();
  const [hausseReceiptsBalance, setHausseReceiptsBalance] = useState<any>();


  useEffect(() => {
    (async () => {
      const dbits = await getERC1155TokenBalancesForAccount(
        PROJ_ADDRESS_1,
        [1],
        );
        if(dbits){
          const balance = ethers.utils.formatEther(dbits)
          setDarkBitsTokenBalance(balance);
          tokenBalances.push(balance)

      }

      const meta = await getERC1155TokenBalancesForAccount(
        PROJ_ADDRESS_2,
        [1],
        );
        if(meta){
          const balance = ethers.utils.formatEther(meta)
          setMetaPortalBalance(balance);
          tokenBalances.push(balance)

      }

      const hausse = await getERC1155TokenBalancesForAccount(
          PROJ_ADDRESS_3,
          [1],
          );
          if(hausse){
            const balance = ethers.utils.formatEther(hausse)
            setHausseReceiptsBalance(balance);
            tokenBalances.push(balance)
        }

        console.log('tokenBalances : ',tokenBalances)
    })();
  
    return () => {
      // this now gets called when the component unmounts
    };
  }, [account]);


  const darkBitsPrice = useGetPriceForProject(
    LIKES_PROXY_V0_ADDRESS,
    account,
    PROJ_ADDRESS_1,
    );
  const metaPortalPrice = useGetPriceForProject(
    LIKES_PROXY_V0_ADDRESS,
      account,
      PROJ_ADDRESS_2,
      );

  const hausseReceiptsPrice = useGetPriceForProject(
        LIKES_PROXY_V0_ADDRESS,
          account,
          PROJ_ADDRESS_3,
          );
    

  let likeProjectFunction  = useContractFunction(contract as any, 'likeProject', { signer: library as any,  transactionName: 'Mint' });
  const doLikeProject = likeProjectFunction.send;


  const getERC1155TokenBalancesForAccount =async(contractAddress: string, tokenIds:  number[]): Promise<any> => {
    if(!contractAddress){
      return null;
    }
    if(!library){
      return null;
    }

    if(!account){
      return null;
    }
    let accounts: string[] = [];
    tokenIds.forEach((tokenId)=> {
      accounts.push(account);
    })

    const signer = library?.getSigner();
    if(!signer){
      return null;
    }

    const contract = get1155Contract(signer, contractAddress);
    console.log('contractAddress : ',contractAddress)
    const value = await contract.balanceOfBatch(accounts, tokenIds);
    console.log('value : ',value)
    return value ? value[0]: null;
 
  }

  function useGetPriceForProject(contractAddress: (string|undefined|null),  account: (string|undefined|null), projectAddress:  (string|undefined|null)): any {
    // const [projectPrice] =
    //   useCall(
    //     account &&
    //     contractAddress && {
    //         abi: LIKESPROXYV0Interface,
    //         address: contractAddress,
    //         method: 'getPriceForProject',
    //         args: [projectAddress],
    //       }
    //   ) ?? []
    // return projectPrice;
    const { value, error } = useCall(contractAddress && {
      contract: new Contract(contractAddress, LIKESPROXYV0Interface) as any,
      method: 'getPriceForProject',
      args:  [projectAddress],
    }) ?? {}
    if(error) {
      console.error(error.message)
      return []
    }
    return value?.[0]
  }

  const doLike = async (projectAddress: string, receiever: string, price: number) => {
    let overrides = {
      value: price
    };
    doLikeProject(projectAddress, receiever,overrides);
  }  


  const hasLiked =(balance: BigNumber): Boolean => {
    if(!balance){
      return false;
    }

    const num = parseFloat( utils.formatEther(balance)) * 10 ** 18
    if (num > 0) {
      return true;
    }
    return false;
  }

  const renderTooltipForUnLiked = (props: any) => (
    <Tooltip id="button-tooltip" {...props}>
      If you like this project, click to purchase a "Proof of Like" NFT. Value Increases the more likes are made.
    </Tooltip>
  );

  const renderTooltipForLiked = (props: any) => (
    <Tooltip id="button-tooltip" {...props}>
      You own this "Proof of Like" NFT! You are free to hold/sell as you wish. 
      You however cannot mint again for this project using the same address.
    </Tooltip>
  );


  return (
    <MainContent>
      <ContainerCustom>
        <Section>
        <SectionRow>
        <Row style={{marginLeft:'1px'}}>
          {(account && chainId !== ChainId.Polygon) && <p>Switch to <b>Polygon Mainnet</b> for more!</p>}
          </Row>
            <AccountButton />
          </SectionRow>
          <SectionRow>
            
          <div style={{display:'flex', marginLeft:'5px'}}>
           {!account && <Badge pill bg="secondary">Dominic Lee</Badge>}
          </div>

          <div style={{display:'flex', marginRight:'5px',marginTop:'5px'}}>
            <svg xmlns="matic-token-icon.svg" x="0px" y="0px"
          width="24" height="24"
          viewBox="0 0 48 48"
          ><path fill="#9fa8da" d="M11 24L25 2 39 24 25 32z"></path><path fill="#7986cb" d="M25 2L39 24 25 32z"></path><path fill="#9fa8da" d="M11 27L25 35 39 27 25 46z"></path><path fill="#7986cb" d="M25 35L39 27 25 46zM11 24L25 18 39 24 25 32z"></path><path fill="#5c6bc0" d="M25 18L39 24 25 32z"></path></svg>
          <img width="24px" src="matic-token-icon.svg" alt="Girl in a jacket"></img>
          </div>

         
    
          </SectionRow>
          <SectionRow>
            {account && <HeaderContentBlock>
            <Row>
                <Col sm={12} md={6} lg={6}>
                      <Image
                      rounded
                      width="120"
                      alt="171x180"
                      src="pfpmesh_compressed.jpeg"
                      />
                </Col>
                <Col >
                  <Row >
                    <Col sm={12} md={12} lg={12}>
                    <h2 >
                    0xdomo.eth
                    </h2>
                    </Col>
                    <Col sm={12} md={12} lg={12}>
                    <div style={{display: 'flex'}}>
                    <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/d0min1cLee">
                      <i className="bi bi-twitter" style={{marginRight:'0.3em', color: 'rgb(29, 155, 240)'}}>
                      </i> 
                    </a>
                    <a target="_blank" rel="noopener noreferrer" href="https://chat.blockscan.com">
                      <i className="bi bi-chat" style={{marginRight:'0.3em'}}></i>
                    </a>
                    </div>
                    </Col>
    
                    {(account && chainId === ChainId.Polygon) && 
                           <Col sm={12} md={12} lg={12}>
                           <Text> 
                              Likes powered by <b><a target="_blank" rel="noopener noreferrer" href="https://polygonscan.com/address/0x83D29F5e551A8a8c3cf3354baD655862d2820A31#code">LikesProxyV0</a></b>
                           </Text>
                           </Col>
                    }
                  </Row>
               </Col>
            </Row>

            </HeaderContentBlock>}

            
          </SectionRow>
          <SectionRow>
          </SectionRow> 

          <SectionRow>
          <ContentBlock>
            <h2 style={{marginBottom:'1em'}}>Recent Projects </h2>
          <ResumeItemBlockList>
            <Row style={{marginBottom:'1em'}}>
              <Col>
               <Row>
               <Col xs={12} sm={12} md={12} lg={4}>
                  <a href="https://dark-bits.web.app/#/" target="_blank" rel="noopener noreferrer">
                  <Image src="./darkbits_thumbnail.png" thumbnail  />
                  </a>
                  </Col>
                  <Col xs={12}  sm={12} md={5} lg={4}>
                    <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                    <p><b>Dark Bits</b></p>
                    </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12} style={{color:'grey'}}>
                      <Text> Entities that can be minted to augment existing NFT ecosystems or kickstart entirely new ones.</Text>
                      </Col>
                    </Row>
                  </Col>
                  
                {  
                  (account && tokenBalances && hasLiked(tokenBalances[0]) === true) && <Col xs={12}  sm={12} md={12} lg={4}>
                      <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltipForLiked}
                        >
                 <i className="bi bi-check-circle" style={{color: '#97c17d', fontSize: '30px'}}></i>
                 </OverlayTrigger>
                 <p> Owned! Value : {formatBalance(darkBitsPrice)} Matic </p>
                 <div>
                          <Link href={getExplorerAddressLink(LIKES_PROXY_V0_ADDRESS, ChainId.Polygon)} target="_blank" rel="noopener noreferrer">
                          Show on polygonscan
                          <LinkIconWrapper>
                          <ShareIcon />
                          </LinkIconWrapper>
                          </Link>
                        </div>

                  </Col>
                }
                {  
                   (account && tokenBalances && hasLiked(tokenBalances[0]) === false) && darkBitsPrice  && <Col xs={12} sm={12} md={12} lg={4}>
                     <div>
                        <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltipForUnLiked}
                        >
                        <i onClick={() => doLike(PROJ_ADDRESS_1, account, darkBitsPrice)} className="bi bi-hand-thumbs-up" style={{color: 'grey', fontSize: '30px'}}></i>
                        </OverlayTrigger>
                        <p> {formatBalance(darkBitsPrice)} Matic </p>
                        <div>
                          <Link href={getExplorerAddressLink(LIKES_PROXY_V0_ADDRESS, ChainId.Polygon)} target="_blank" rel="noopener noreferrer">
                          Show on polygonscan
                          <LinkIconWrapper>
                          <ShareIcon />
                          </LinkIconWrapper>
                          </Link>
                        </div>
                    </div>
                      
                  </Col>
                }

                </Row>
                </Col>
              </Row>

              <Row style={{marginBottom:'1em'}}>
                <Col xs={12} sm={12} md={12} lg={4}>
                  <a href="https://metaportal-e057a.web.app/" target="_blank" rel="noopener noreferrer">
                  <Image src="./metaportal_thumbnail.png" thumbnail  />
                  </a>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={4}>
                    <Row>
                    <Col xs={12} md={12} lg={12}>
                    <p><b>Meta Portal</b></p>
                    </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={12} lg={12} style={{color:'grey'}}>
                      <Text> On-chain achievements based on the activity related to your web3 wallet address.                         
                      </Text>
                      </Col>
                    </Row>
                  </Col>
                  {  
                  (account && tokenBalances && hasLiked(tokenBalances[1]) === true) && <Col xs={12} sm={12} md={12} lg={4}>
                      <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltipForLiked}
                        >
                  <i className="bi bi-check-circle" style={{color: '#97c17d', fontSize: '30px'}}></i>
                  </OverlayTrigger>
                  <p> Owned! Value : {formatBalance(metaPortalPrice)} Matic </p>
                  <div>
                          <Link href={getExplorerAddressLink(LIKES_PROXY_V0_ADDRESS, ChainId.Polygon)} target="_blank" rel="noopener noreferrer">
                          Show on polygonscan
                          <LinkIconWrapper>
                          <ShareIcon />
                          </LinkIconWrapper>
                          </Link>
                        </div>
                  </Col>
                }
                {  
                   (account && tokenBalances && hasLiked(tokenBalances[1]) === false ) && metaPortalPrice && <Col xs={12} sm={12} md={12} lg={4}>
                     <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltipForUnLiked}
                        >
                    <i onClick={() =>  doLike(PROJ_ADDRESS_2, account, metaPortalPrice)} className="bi bi-hand-thumbs-up" style={{color: 'grey', fontSize: '30px'}}></i>
                    </OverlayTrigger>
                    <p> {formatBalance(metaPortalPrice)} Matic </p>
                    <div>
                          <Link href={getExplorerAddressLink(LIKES_PROXY_V0_ADDRESS, ChainId.Polygon)} target="_blank" rel="noopener noreferrer">
                          Show on polygonscan
                          <LinkIconWrapper>
                          <ShareIcon />
                          </LinkIconWrapper>
                          </Link>
                        </div>
                  </Col>
                }
              </Row>

              <Row style={{marginBottom:'1em'}}>
                <Col xs={12} sm={12} md={12} lg={4}>
                  <a href="https://www.youtube.com/watch?v=RaMMRLU8Vzs&ab_channel=Dominic" target="_blank" rel="noopener noreferrer">
                  <Image src="./digital_receipts_thumbnail.png" thumbnail  />
                  </a>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={4}>
                    <Row>
                    <Col xs={12} md={12} lg={12}>
                    <p><b>Digital Receipts (Proof of Concept)</b></p>
                    </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={12} lg={12} style={{color:'grey'}}>
                      <Text> Platform that bootstraps any POS desktop software with 
                        transferrable digital receipts.                      
                      </Text>
                      </Col>
                    </Row>
                  </Col>
                  {  
                  (account && tokenBalances && hasLiked(tokenBalances[2]) === true) && <Col xs={12} sm={12} md={12} lg={4}>
                      <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltipForLiked}
                        >
                  <i className="bi bi-check-circle" style={{color: '#97c17d', fontSize: '30px'}}></i>
                  </OverlayTrigger>
                  <p> Owned! Value : {formatBalance(hausseReceiptsPrice)} Matic </p>
                  <div>
                          <Link href={getExplorerAddressLink(LIKES_PROXY_V0_ADDRESS, ChainId.Polygon)} target="_blank" rel="noopener noreferrer">
                          Show on polygonscan
                          <LinkIconWrapper>
                          <ShareIcon />
                          </LinkIconWrapper>
                          </Link>
                        </div>
                  </Col>
                }
                {  
                   (account && tokenBalances && hasLiked(tokenBalances[2]) === false ) && hausseReceiptsPrice && <Col xs={12} sm={12} md={12} lg={4}>
                     <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltipForUnLiked}
                        >
                    <i onClick={() =>  doLike(PROJ_ADDRESS_3, account, hausseReceiptsPrice)} className="bi bi-hand-thumbs-up" style={{color: 'grey', fontSize: '30px'}}></i>
                    </OverlayTrigger>
                    <p> {formatBalance(hausseReceiptsPrice)} Matic </p>
                    <div>
                          <Link href={getExplorerAddressLink(LIKES_PROXY_V0_ADDRESS, ChainId.Polygon)} target="_blank" rel="noopener noreferrer">
                          Show on polygonscan
                          <LinkIconWrapper>
                          <ShareIcon />
                          </LinkIconWrapper>
                          </Link>
                        </div>
                  </Col>
                }
              </Row>
            </ResumeItemBlockList>
          </ContentBlock>
          </SectionRow>
          <SectionRow>
          <ContentBlock>
          <h2 style={{marginBottom:'1em'}}>Skills </h2>
            <ResumeItemBlockList>
              <Row>
                <Col xs={6} md={3} lg={3}>
                <Badge pill bg="dark">React</Badge>
                </Col>
                <Col xs={6}  md={3} lg={3}>
                <Badge pill bg="dark">Vue 2</Badge>
                </Col>   
                <Col xs={6}  md={3} lg={3}>
                <Badge pill bg="dark">Flutter</Badge>
                </Col>   
                <Col xs={6}  md={3} lg={3}>
                <Badge pill bg="dark">Node</Badge>
                </Col>
                <Col xs={6}  md={3} lg={3}>
                <Badge pill bg="dark">Solidity</Badge>
                </Col>
                <Col xs={6}  md={3} lg={3}>
                <Badge pill bg="dark">hardhat</Badge>
                </Col>
                <Col xs={6}  md={3} lg={3}>
                <Badge pill bg="dark">ethers.js</Badge>
                </Col>
              </Row>

    
            </ResumeItemBlockList>
          </ContentBlock>
          </SectionRow>

          <SectionRow>
            <ContentBlock>
                <h2 style={{marginBottom:'1em'}}>Resume Links </h2>
                <Row>
                    <Col xs={4} sm={4} md={4}>
                    <a href="https://www.linkedin.com/in/dominic-lee-62577bb8/" target="_blank" rel="noopener noreferrer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
                      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"/>
                    </svg>
                    </a>
                    </Col>
                    <Col xs={4} sm={4} md={4}>
                    <a href={'./resume.pdf'} target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-card-checklist" viewBox="0 0 16 16">
                      <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/>
                      <path d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"/>
                    </svg> 
                    </a>                
                    </Col>
                    <Col xs={4} sm={4} md={4}>
                    <a href="https://github.com/d0m0l33" target="_blank" rel="noopener noreferrer">

                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-github" viewBox="0 0 16 16">
                      <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z"/>
                    </svg>
                    </a>
                    </Col>
                </Row>
            </ContentBlock>
          </SectionRow>
        </Section>
      </ContainerCustom>
    </MainContent>
  )
}

const LinkWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`

const LinkIconWrapper = styled.div`
  width: 12px;
  height: 12px;
`

const HeaderContentBlock = styled(ContentBlock)`
  background-color: #e2dde3;
  
`
const ResumeItemBlockList = styled.div `
  backgroundColor: grey;
`

const ResumeItemBlock = styled.div`
  margin-top: 1em;
`


